import React from "react";
import { DnxSwitch } from "*external*/@cisco-dna/dnx-react-components";
import { store as store$ } from "./FeatureFlags";
import { HbrBadge } from "@harbor/elements-react";

export const StoreContext = React.createContext(store$);

export function DeveloperPage(): JSX.Element {
   const store = React.useContext(StoreContext);
   const systemFlags = store.flags.filter((x) => x.source === "system");

   return (
      <div style={{ padding: 40 }}>
         <h1>Feature Flags</h1>

         {store.flags
            .filter((it) => it.source === "contribution")
            .map((flag) => {
               if (flag.deprecated) {
                  return (
                     <div key={flag.id} style={{ color: "#999" }}>
                        <h4 style={{ textDecoration: "italic" }}>
                           {flag.id}{" "}
                           <HbrBadge pill size="small">
                              deprecated
                           </HbrBadge>
                        </h4>
                        <div style={{ opacity: 0.8 }}>{flag.deprecated}</div>
                     </div>
                  );
               }

               return (
                  <div key={flag.id}>
                     <h4>{flag.id}</h4>
                     <DnxSwitch
                        key={flag.id}
                        flavor="checkbox"
                        label={flag.label}
                        value={flag.enabled()}
                        change={(e) =>
                           e.currentTarget.value
                              ? store.enable(flag.id)
                              : store.disable(flag.id)
                        }
                     />
                  </div>
               );
            })}

         {systemFlags.length > 0 && (
            <div>
               <h4>System</h4>
               {systemFlags.map((flag) => (
                  <DnxSwitch
                     key={flag.id}
                     flavor="checkbox"
                     label={flag.label}
                     value={flag.enabled()}
                     disabled={true}
                  />
               ))}
            </div>
         )}
      </div>
   );
}
